import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAxiosPost from "../../hooks/useAxiosPost";
import TailSpinLoader from "../Items/Loaders/TailSpinLoader";
import ConnectionProfileDetailsLeftCard from "./cards/ConnectionProfileDetailsLeftCard";
import ConnectionProfileDetailsRightCard from "./cards/ConnectionProfileDetailsRightCard";
const ConnectionDetailsComponent = () => {
  const [singleConnection, setSingleConnection] =
    useState<SingleConnectionApiResponse | null>(null);
  const [companySettings, SetCompanySettings] =
    useState<CompanySettingsApiProp | null>(null);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ConnectionUserDetailsProp>(
    "connections/getConnectionsByConnectionID"
  );
  const { intPkConnectionID } = useParams();
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const { connectionDetails, companySettings } = data;
      setSingleConnection(connectionDetails);
      SetCompanySettings(companySettings);
    }
  }, [apiResponse]);
  useEffect(() => {
    postApiData({ intPkConnectionID: Number(intPkConnectionID) });
  }, []);
  const handleReload = (reload: boolean) => {
    postApiData({ intPkConnectionID: Number(intPkConnectionID) });
  };
  return (
    <>
      {apiLoading === true ? (
        <TailSpinLoader />
      ) : (
        <Row gutter={30}>
          <Col span={12}>
            {singleConnection && companySettings && (
              <ConnectionProfileDetailsLeftCard
                singleConnection={singleConnection}
                isReload={handleReload}
                settings={companySettings}
              />
            )}
          </Col>
          {singleConnection &&
            Number(singleConnection.isConnectionActivated) === 1 && (
              <Col span={12}>
                {companySettings && (
                  <ConnectionProfileDetailsRightCard
                    singleConnection={singleConnection}
                    isReload={handleReload}
                    settings={companySettings}
                  />
                )}
              </Col>
            )}
        </Row>
      )}
    </>
  );
};
export default ConnectionDetailsComponent;
